export const getFillFields = (dataName: string) =>
    document.querySelectorAll(`[data-${dataName}]`);
